var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssetDeviceDefaultMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#af0e38;stroke:#af0e38;stroke-width:5px;}.cls-2,.cls-4{stroke-miterlimit:10;}.cls-3{fill:#112034;}.cls-4{fill:#1d3557;stroke:#fff;stroke-width:3px;}.cls-5{fill:#4a5d79;}.cls-6{fill:#617c99;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 108,
    cy: 93.16,
    r: 54.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M173.68,93.19A65.68,65.68,0,1,0,64.5,142.39l37.6,43.51a7.52,7.52,0,0,0,11.37,0l36.34-42.05A65.56,65.56,0,0,0,173.68,93.19ZM108,36.75A54.78,54.78,0,1,1,53.22,91.53,54.79,54.79,0,0,1,108,36.75Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 73.83,
    y: 56.83,
    width: 56.84,
    height: 38.72,
    rx: 2.13
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M139.9,82.26H103.28a4,4,0,0,0-3.93,4v36.66a4,4,0,0,0,3.93,4H139.9a4,4,0,0,0,3.93-4V86.25A4,4,0,0,0,139.9,82.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76,98.65H97.76a0,0,0,0,1,0,0v24.61a2.09,2.09,0,0,1-2.09,2.09H76a2.09,2.09,0,0,1-2.09-2.09V100.74A2.09,2.09,0,0,1,76,98.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M134.73,56.91h6.6a1,1,0,0,1,1,1V79.58a1.18,1.18,0,0,1-1.18,1.18h-7.39a0,0,0,0,1,0,0V57.9A1,1,0,0,1,134.73,56.91Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetDeviceDefaultMarker);
export default __webpack_public_path__ + "static/media/AssetDevice_default_Marker.1be891e9a2a4e7285ac1795033746756.svg";
export { ForwardRef as ReactComponent };